// client/src/components/products/Pagination.js
import React from 'react';

const Pagination = ({ productsPerPage, totalProducts, paginate, currentPage }) => {
  const totalPages = Math.ceil(totalProducts / productsPerPage);

  if (totalPages <= 1) return null;

  const startItem = (currentPage - 1) * productsPerPage + 1;
  const endItem = Math.min(currentPage * productsPerPage, totalProducts);

  // Build smart page list with ellipses when totalPages is large
  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [1];
    const leftSibling = Math.max(currentPage - 1, 2);
    const rightSibling = Math.min(currentPage + 1, totalPages - 1);

    if (leftSibling > 2) {
      pages.push('ellipsis-left');
    }

    for (let i = leftSibling; i <= rightSibling; i++) {
      pages.push(i);
    }

    if (rightSibling < totalPages - 1) {
      pages.push('ellipsis-right');
    }

    pages.push(totalPages);
    return pages;
  };

  const pageItems = getPageNumbers();

  const handlePageSelect = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    paginate(page);
  };

  return (
    <nav className="pagination-nav" aria-label="Product catalog pagination">
      <div className="pagination-summary">
        Showing <strong>{startItem}</strong>–<strong>{endItem}</strong> of{' '}
        <strong>{totalProducts}</strong> products (Page <strong>{currentPage}</strong> of{' '}
        <strong>{totalPages}</strong>)
      </div>

      <ul className="pagination">
        {/* Previous Page Button */}
        <li className={`page-item page-item-nav ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link page-nav-btn"
            onClick={() => handlePageSelect(currentPage - 1)}
            disabled={currentPage === 1}
            aria-label="Go to previous page"
          >
            <i className="fas fa-chevron-left"></i>
            <span>Previous</span>
          </button>
        </li>

        {/* Page Number Pills */}
        {pageItems.map((item) => {
          if (typeof item === 'string') {
            return (
              <li key={item} className="page-item page-ellipsis" aria-hidden="true">
                <span>&hellip;</span>
              </li>
            );
          }

          const isActive = currentPage === item;
          return (
            <li key={item} className={`page-item ${isActive ? 'active' : ''}`}>
              <button
                type="button"
                onClick={() => handlePageSelect(item)}
                className="page-link"
                aria-current={isActive ? 'page' : undefined}
                aria-label={`Page ${item}`}
              >
                {item}
              </button>
            </li>
          );
        })}

        {/* Next Page Button */}
        <li className={`page-item page-item-nav ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button
            type="button"
            className="page-link page-nav-btn"
            onClick={() => handlePageSelect(currentPage + 1)}
            disabled={currentPage === totalPages}
            aria-label="Go to next page"
          >
            <span>Next</span>
            <i className="fas fa-chevron-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
